import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  MDBBtn,
  MDBIcon,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdb-react-ui-kit";
import PopupLoader from "../../../views/popups/PopupLoader";
import AddExternalNumbr from "../../../views/popups/users/AddExternalNumber";
import DeleteExternalNumber from "../../../views/popups/users/DeleteExternalNum";
import EditExternalNumbr from "../../../views/popups/users/EditExternalNumber";
import { Tooltip } from "react-tooltip";
import PopupLoaderNew from "../../../views/popups/PopupLoaderNew";
import { formattedNumber } from "../../../views/popups/phonenumbers/AddRemoveNumbers";
import { getMisc } from "../../../apiclients/streamsapi_bridge";
function UserExternalNumbers({
  register,
  errors,
  externalNumbers,
  useragent,
  setSuccessMessage,
  getValues,
  setError,
  clearErrors,
  setErrorMessage,
  callAssignment,
  setCallAssignment,
}) {
  const { t, i18n } = useTranslation();
  const [existexternalNumbers, setExistExternalNumbers] = useState([]);
  const [newNumber, setNewNumber] = useState({});
  const [editNumber, setEditNumber] = useState({});
  const [AddExternalNumber, setAddExternalNumbers] = useState(false);
  const [EditExternalNumber, setEditExternalNumbers] = useState(false);
  const [extnumdetails, setExtNumDetails] = useState({});
  const [finalEditExternal, setFinalEditExternal] = useState([]);
  const toggleExternalNumbers = () => setAddExternalNumbers(!AddExternalNumber);
  const [isdeleteNumber, setIsDeleteNumbers] = useState(false);
  const dtogglePopup = () => setIsDeleteNumbers(!isdeleteNumber);
  const [deleteEXNumber, setDeleteEXNumber] = useState({});
  const [newExternalNum, setNewExternalNum] = useState({});
  const [isExternalModify, setIsExternalModify] = useState(false);
  const [deleteExternalFlag, setDeleteExternalFlag] = useState(false);
  const addExtNumRef = useRef(null);
  const [addExternalFlag, setaddExternalFlag] = useState(false);
  const [isLoading, setisLoading] = useState(false);

  function handleClick() {
    addExtNumRef.current.click();
  }

  const toggleEditExternalNumbers = (title, number, id) => {
    setExtNumDetails({
      id: id,
      title: title,
      number: number,
    });
    setEditExternalNumbers(!EditExternalNumber);
  };

  function createFinalAddList() { }

  function createFinalEditList() { }

  function createFinalRemoveList() { }
  useEffect(() => {
    if (externalNumbers) {
      // debugger;
      const defaultExternal = [
        {
          title: "Cell Phone",
          phNumber: "",
          id: 0,
        },
      ];
      if (externalNumbers.length > 0) {
        const cellPhoneObj = externalNumbers.find(
          (num) => num.title === "Cell Phone"
        );
        if (!cellPhoneObj) {
          setExistExternalNumbers([...defaultExternal, ...externalNumbers]);
        } else {
          setExistExternalNumbers(externalNumbers);
        }
      } else {
        setExistExternalNumbers(defaultExternal);
      }
    }
  }, [externalNumbers]);

  useEffect(() => {
    if (isExternalModify) {
      modifyExistingExternalNum();
    }
  }, [isExternalModify]);

  async function fetchCallAssignment() {
      console.log(sessionStorage.getItem("admin_session"));
      const response = await getMisc(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        { misc: ["mobile_call_pref"], agentid: useragent }
      );
      if (!response.json) {
        const message = `An error has occured: ${response.statusText}`;
        return;
      }
      const tdata = await response.json();
      if (!tdata) {
        window.alert(`info with id  not found`);
        // navigate("/");
      }
      let callassign = tdata.misc.mobile_call_pref ?? [];
      callassign = Object.entries(callassign)?.map(([key, value]) => ({
        value: parseInt(value),
        text: key,
      }));
      setCallAssignment(callassign);
   
    }

  function modifyExistingExternalNum() {
    let updatedNum = [];
    //alert(JSON.stringify(newExternalNum) + "  :::: newExternalNum")

    const { phNumber, phNum, ...rest } = newExternalNum;
    const updatedObj = {
      ...rest,
      phNumber: phNum ?? phNumber,
    };

    let extrnalNum = [];
    if (addExternalFlag) {
      extrnalNum = existexternalNumbers.filter(
        (item) => item.id !== updatedObj.id
      );
      const cellPhoneObj = extrnalNum.find(
        (item) => item.title === "Cell Phone"
      );
      const excludeextrnalNum = extrnalNum.filter((item) => item.title !== "Cell Phone");
      extrnalNum = [...excludeextrnalNum, updatedObj].sort((a, b) =>
        a.title.localeCompare(b.title)
      );
      extrnalNum = [cellPhoneObj, ...extrnalNum];
    } else if (deleteExternalFlag) {
      extrnalNum = existexternalNumbers.filter(
        (item) => item.id !== updatedObj.id
      );
      setDeleteExternalFlag(false);
    } else {
      extrnalNum = existexternalNumbers.map((item) =>
        item.id === updatedObj.id
          ? { ...item, phNumber: updatedObj.phNumber, title: updatedObj.title }
          : item.title === "Cell Phone" && updatedObj.title === "Cell Phone"
          ? {
              id: updatedObj.id,
              phNumber: updatedObj.phNumber,
              title: updatedObj.title,
            }
          : item
      );


    }
    // else {
    //   extrnalNum = existexternalNumbers.filter(
    //     (item) => item.id !== updatedObj.id && parseInt(item.id) !== 0
    //   );
    // }

    // if (deleteExternalFlag) {
    //   updatedNum = [...extrnalNum];
    //   setDeleteExternalFlag(false);
    // }
    // else if (addExternalFlag) {
    //   updatedNum = [...extrnalNum, updatedObj];
    // } else {
    updatedNum = [...extrnalNum];
    // }
    fetchCallAssignment();
    setaddExternalFlag(false);
    setIsExternalModify(false);
    setExistExternalNumbers(updatedNum);
  }
  function deleteNumber(number, id) {
    dtogglePopup();
    setDeleteEXNumber({
      id: id,
      phNum: parseInt(number),
    });
  }

  useEffect(() => {
    if (editNumber) {
      createFinalAddList();
    }
  }, [newNumber]);

  useEffect(() => {
    if (editNumber) {
      createFinalEditList();
    }
  }, [editNumber]);
  return (
    <>
      <div className="mt-4 d-flex justify-content-between align-items-center">
        <div className="general-settings">{t("ExternalNumbers")}</div>
        <div>
          <MDBBtn
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation(); // Prevent the form submission
              toggleExternalNumbers(); // Open the modal
            }}
          >
            <MDBIcon fas icon="plus" size="sm" /> {t("addExternal")}
          </MDBBtn>
        </div>
      </div>
      <div className="" style={{ paddingLeft: "7px" }}>
        <MDBTable className="mt-2 actioncolumn">
          <MDBTableHead>
            <tr>
              <th scope="col" className="w-20">
                Name
              </th>
              <th scope="col" className="w-70">
                Number
              </th>
              <th scope="col" className="text-center w-10">
                Remove
              </th>
            </tr>
          </MDBTableHead>
          <MDBTableBody>
            {existexternalNumbers &&
              existexternalNumbers.map((externum) => (
                <>
                  <tr
                    onClick={(e) => {
                      e.preventDefault(); // Prevent the form submission
                      toggleEditExternalNumbers(
                        externum.title,
                        externum.phNumber,
                        externum.id
                      ); // Open the modal
                    }}
                  >
                    <td scope="row">{externum.title}</td>
                    <td>{formattedNumber(externum.phNumber)}</td>
                    <td className="text-center">
                      {externum.title !== "Cell Phone" && (
                        <>
                          {/* <i
      <MDBTable className="mt-2 actioncolumn">
        <MDBTableHead>
          <tr>
            <th scope="col" className="w-20">
              Name
            </th>
            <th scope="col" className="w-70">
              Number
            </th>
            <th scope="col" className="text-center w-10">
              Remove
            </th>
          </tr>
        </MDBTableHead>
        <MDBTableBody>
          {existexternalNumbers &&
            existexternalNumbers.map((externum) => (
              <>
                <tr
                  onClick={(e) => {
                    e.preventDefault(); // Prevent the form submission
                    toggleEditExternalNumbers(
                      externum.title,
                      externum.phNumber,
                      externum.id
                    ); // Open the modal
                  }}
                >
                  <td scope="row">{externum.title}</td>
                  <td>{formattedNumber(externum.phNumber)}</td>
                  <td className="text-center">
                    {externum.title !== "Cell Phone" && (
                      <>
                        {/* <i
                          className="fas fa-xmark text-primary cursor-pointer"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation(); // Stop event propagation
                            deleteNumber(externum.phNumber, externum.id);
                          }}
                        ></i> */}
                          <div>
                            <div
                              className="custom-hover-bg p-1 cursor-pointer deleteToolTip"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation(); // Stop event propagation
                                deleteNumber(externum.phNumber, externum.id);
                              }}
                            >
                              <MDBIcon
                                fas
                                icon="times"
                                color="primary"
                                className="fs-5"
                              />
                            </div>
                          </div>
                        </>
                      )}
                    </td>
                  </tr>
                </>
              ))}
          </MDBTableBody>
        </MDBTable>
      </div>
      {AddExternalNumber && (
        <PopupLoaderNew
          //size="lg"
          //className="modal-lg"
          title={"Add External Number"}
          content={
            <AddExternalNumbr
              existexternalNumbers={existexternalNumbers}
              finalEditExternal={finalEditExternal}
              useragent={useragent}
              setNewExternalNum={setNewExternalNum}
              setIsExternalModify={setIsExternalModify}
              onClose={toggleExternalNumbers}
              setSuccessMessage={setSuccessMessage}
              setErrorMessage={setErrorMessage}
              ref={addExtNumRef}
              setIsloading={setisLoading}
              setaddExternalFlag={setaddExternalFlag}
            />
          }
          onShow={setAddExternalNumbers}
          onClose={toggleExternalNumbers}
          onSave={handleClick}
          isloading={isLoading}
          flag={1}
        />
      )}
      {EditExternalNumber && (
        <PopupLoaderNew
          // size="lg"
          // className="modal-lg"
          title={"Edit External Number"}
          content={
            <EditExternalNumbr
              extnumdetails={extnumdetails}
              existexternalNumbers={existexternalNumbers}
              finalEditExternal={finalEditExternal}
              setEditNumber={setEditNumber}
              useragent={useragent}
              setNewExternalNum={setNewExternalNum}
              setIsExternalModify={setIsExternalModify}
              setSuccessMessage={setSuccessMessage}
              setErrorMessage={setErrorMessage}
              onClose={toggleEditExternalNumbers}
              ref={addExtNumRef}
              setIsloading={setisLoading}
              setaddExternalFlag={setaddExternalFlag}
            />
          }
          onShow={setEditExternalNumbers}
          onClose={toggleEditExternalNumbers}
          onSave={handleClick}
          isloading={isLoading}
          flag={5}
        />
      )}

      {isdeleteNumber && (
        <PopupLoaderNew
          title={"Remove External Number"}
          content={
            <DeleteExternalNumber
              useragent={useragent}
              deleteEXNumber={deleteEXNumber}
              setNewExternalNum={setNewExternalNum}
              setIsExternalModify={setIsExternalModify}
              setDeleteExternalFlag={setDeleteExternalFlag}
              onClose={dtogglePopup}
              setSuccessMessage={setSuccessMessage}
              setErrorMessage={setErrorMessage}
              ref={addExtNumRef}
              setIsloading={setisLoading}
            />
          }
          onShow={setIsDeleteNumbers}
          onClose={dtogglePopup}
          onSave={handleClick}
          isloading={isLoading}
          flag={4}
        />
      )}

      <Tooltip
        anchorSelect=".deleteToolTip"
        place="top"
        className="exampleTooltip"
      >
        Remove
      </Tooltip>
    </>
  );
}

export default UserExternalNumbers;
